/*! @azure/msal-browser-1p v2.37.1 2023-06-12 */
'use strict';
import { __extends } from '../_virtual/_tslib.js';
import { PublicClientApplication as PublicClientApplication$1 } from '@azure/msal-browser';
import { PerformanceTelemetryReporter } from '../telemetry/PerformanceTelemetryReporter.js';

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
var PublicClientApplication = /** @class */ (function (_super) {
    __extends(PublicClientApplication, _super);
    function PublicClientApplication(configuration, firstPartyConfiguration) {
        var _this = _super.call(this, configuration) || this;
        /*
         * TODO: Don't initialize wrapper until eSTS is updated to include new SKU
         * this.initializeWrapperLibrary(WrapperSKU.FirstParty, version);
         */
        var telemetryReporter = new PerformanceTelemetryReporter(_this.getLogger(), firstPartyConfiguration === null || firstPartyConfiguration === void 0 ? void 0 : firstPartyConfiguration.performanceTelemetryConfiguration);
        _this.addPerformanceCallback(telemetryReporter.getPerformanceTelemetryCallback());
        return _this;
    }
    return PublicClientApplication;
}(PublicClientApplication$1));

export { PublicClientApplication };
//# sourceMappingURL=PublicClientApplication.js.map
